import React, { useState } from "react";
import { Col, Row, Form, InputGroup } from "react-bootstrap";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "./styles.scss";
import Button from "../Button";
import ReCAPTCHA from "react-google-recaptcha";

export default function RequestMoreInformation() {
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    class: "",
    phone: "",
    message: "",
    option: ""
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };



  function onChange(value) {
    console.log("Captcha value:", value);
    setCaptchaVerified(true); // Set captcha verification status
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    // Simple field validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message || !formData.option || !formData.class) {
      setCaptchaErrorMessage("Please fill in all required fields.");
      return;
    }
  
    if (!captchaVerified) {
      setCaptchaErrorMessage("Please complete the CAPTCHA!");
      return;
    }
  
    try {
      const response = await fetch("https://your-api-endpoint.com/api/form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
  
      if (response.ok) {
        setFormSubmitted(true);
        setCaptchaErrorMessage(""); // clear any previous error
        setFormData({
          name: "",
          email: "",
          phone: "",
          class: "",
          message: "",
          option: ""
        });
      } else {
        const errorData = await response.json();
        setCaptchaErrorMessage(errorData.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setCaptchaErrorMessage("Server error. Please try again later.");
    }
  };
  

  return (
    <>
      {!formSubmitted ? (

        <div className="requestInformationWrapper">
          <form onSubmit={handleFormSubmit}>
            <Row>
              <Col md={12}>
                <InputGroup className="mb-3">
                  <Form.Control
                    placeholder="Name*"
                    aria-label="Name"
                    className="input-form"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </InputGroup>
              </Col>


              <Col sm={12}>
                <InputGroup className="mb-3">
                  <Form.Control
                    placeholder="Email*"
                    aria-label="Email"
                    className="input-form"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </InputGroup>
              </Col>



              <Col sm={12}>
                <InputGroup className="mb-3">
                  <PhoneInput
                    international
                    countryCallingCodeEditable={true}
                    placeholder="Enter phone number"
                    value={formData.phone} 
                    onChange={(value) => setFormData({ ...formData, phone: value })}
                    className="phone-number-input-form"
                    defaultCountry="IN"
                   /*  enableAreaCodes={true} */
                    name="phone" // Name attribute directly specified here
                  />
                </InputGroup>
              </Col> 

              <Col sm={12}>
                <InputGroup className="mb-3">
                  <Form.Select
                    className="select-dropdown"
                    aria-label="Default select example"
                    name="class"
                    value={formData.class}
                    onChange={handleInputChange}
                  >
                    <option>Select class*</option>
<option value="ICSE Class 9">ICSE Class 9</option>
<option value="ICSE Class 10">ICSE Class 10</option>
<option value="ICSE Class 11">ICSE Class 11</option>
<option value="ICSE Class 12">ICSE Class 12</option>
               

                  </Form.Select>
                </InputGroup>
              </Col>

             

              <Col md={12}>
                <div className="radio-box">
                  {["radio"].map((type) => (
                    <div key={`inline-${type}`} className="mb-3">
                      <span className="me-2 fw-bold label-radio">For*:</span>

                      <Form.Check
                        inline
                        label="My Self"
                        name="option"
                        type={type}
                        id={`inline-${type}-1`}
                        value="self"
                        onChange={handleInputChange}
                      />
                      <Form.Check
                        inline
                        label="My Company"
                        name="option"
                        type={type}
                        id={`inline-${type}-2`}
                        value="company"
                        onChange={handleInputChange}
                      />
                    </div>
                  ))}
                </div>
              </Col>

              <Col md={12}>
                <InputGroup className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Message*"
                    aria-label="Message"
                    className="input-form"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                </InputGroup>
              </Col>

              




              <Col sm={6} className="mb-3">
                <ReCAPTCHA
                  sitekey="6LdOhwQrAAAAAPEnW5DLqd078hsiQGXGy3NC0I6q"
                  onChange={onChange}
                />
              </Col>
              <Col md={12}>
                {captchaErrorMessage && <span className="text-danger">{captchaErrorMessage}</span>}
              </Col>


              <Col sm={12}>
                <div className="request-form-btn">
                  <Button className="submit-btn w-75  btncomponent" type="submit">Submit</Button>
                </div>
              </Col>
            </Row>
          </form>
        </div>)
        :
        (<div>
          {formSubmitted && (
            <p className="mt-3 fw-bold">
              Form submitted successfully!
            </p>
          )}
        </div>
        )
      }
    </>
  );
}
